// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-result-container-details {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  color: #979EA4;
  padding-top: 30px;
  font-size: 16px;
  margin-bottom: 20px;
}

.no-result-container-details img {
  height: 100px;
}

.MuiDataGrid-virtualScrollerContent.css-1kwdphh-MuiDataGrid-virtualScrollerContent {
  flex-basis: var(--DataGrid-overlayHeight, calc(var(--height) * 5)) !important;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/NoResultAtributtes/NoResultAtributtes.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6EAA6E;AAC/E","sourcesContent":[".no-result-container-details {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 20px;\n  color: #979EA4;\n  padding-top: 30px;\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n\n.no-result-container-details img {\n  height: 100px;\n}\n\n.MuiDataGrid-virtualScrollerContent.css-1kwdphh-MuiDataGrid-virtualScrollerContent {\n  flex-basis: var(--DataGrid-overlayHeight, calc(var(--height) * 5)) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
